import React from 'react'

import RegisterValidateForm from 'presentation/patient/components/Forms/RegisterValidate'

export default function RegisterValidateLayout() {
  return <RegisterValidateForm />
}
